import { CONFIGURATION } from '../setup/component-lib.esm.js';
function useConfiguration() {
  return {
    ...CONFIGURATION
  };
}
export { useConfiguration };